// 引入后端api
import { getWorkflowBusinessApi } from '@/api/workflow'
// 引入数据字典
import { workflowBusinessTypeDict } from '@/dictionary/workflow'

const state = {
  // 审核流--审批类型字典
  workflowBusinessList: [],
  // 审核类型对应的中文
  workflowBusinessObject: {}
}

const mutations = {
  SET_WORKFLOW_BUSINESS_LIST: (state, workflowBusinessList) => {
    state.workflowBusinessList = workflowBusinessList
  },

  SET_WORKFLOW_BUSINESS_OBJECT: (state, workflowBusinessObject) => {
    state.workflowBusinessObject = workflowBusinessObject
  }
}

const actions = {
  /**
   * 获取审核流审批类型字典，并处理出审批类型对应的中文字典
   * @returns {Promise<unknown>}
   */
  getWorkflowBusinessDict({ commit, rootState }) {
    return new Promise((resolve, reject) => {
      getWorkflowBusinessApi()
        .then(res => {
          const workflowBusinessObject = {}

          const getListLoop = list => {
            return list.map(value => {
              const temp = { label: value.name }
              if (value.type === workflowBusinessTypeDict.BUSINESS_TYPE.value) {
                temp.value = value.businessType
                if (!(value.businessType in workflowBusinessObject)) {
                  workflowBusinessObject[value.businessType] = value.name
                }
              }
              if (value.type === workflowBusinessTypeDict.BUSINESS_NODE.value) {
                temp.value = value.businessNode
                if (!(value.businessNode in workflowBusinessObject)) {
                  workflowBusinessObject[value.businessNode] = value.name
                }
              }
              if (value.children && value.children.length) {
                temp.children = getListLoop(value.children)
              }

              return temp
            })
          }

          // 当有五菱招标的灰度时候，去除掉云采购的招标，采用五菱招标
          let workflowBusinessList = getListLoop(res.data || [])

          const greyFeatures = rootState.company.greyFeatures || []
          const companyId = rootState.company.companyId || ''

          const wulingItem = greyFeatures.find(el => el.code === 'wuling') || {}
          if ((wulingItem.companyIds || []).includes(companyId)) {
            workflowBusinessList = workflowBusinessList.filter(el => el.value !== 'bidding')
          }

          commit('SET_WORKFLOW_BUSINESS_LIST', workflowBusinessList)
          commit('SET_WORKFLOW_BUSINESS_OBJECT', workflowBusinessObject)

          resolve({
            workflowBusinessList,
            workflowBusinessObject
          })
        })
        .catch(err => {
          reject(err)
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
